import React from 'react'
import { GroupSelectionWrapper } from './styles'
import { startCase } from 'lodash'

const GroupSelector = ({ groups, selectedGroup, setSelectedGroup }) => {
  return (
    <div>
      {groups && selectedGroup && (
        <GroupSelectionWrapper basis={Object.keys(groups).length}>
          <ul>
            {Object.keys(groups).map((group, i) => (
              <li
                key={i}
              >
                <button
                  className={selectedGroup === group ? 'selected-group' : ''}
                  onClick={() => setSelectedGroup(group)}
                >
                  {startCase(group)}
                </button>
              </li>
            ))}
          </ul>
        </GroupSelectionWrapper>
      )}
    </div>
  )
}

export default GroupSelector
